import { createSlice } from '@reduxjs/toolkit'
import { ISupportSocials } from 'models/Support/ISupportSocials'

export interface SupportState {
  isLoading: boolean
  isSendSupportMessageSuccess: boolean
  isSendSupportMessageFailed: boolean
  isGetSupportSocialsSuccess: boolean
  supportSocials: ISupportSocials[] | null
  supportMessageResponse: any | null
}

const initialState: SupportState = {
  isLoading: false,
  isSendSupportMessageSuccess: false,
  isSendSupportMessageFailed: false,
  isGetSupportSocialsSuccess: false,
  supportSocials: null,
  supportMessageResponse: null,
}

const supportSlice = createSlice({
  name: 'support',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
      state.isSendSupportMessageSuccess = false
      state.isSendSupportMessageFailed = false
    },
    apiFailure: (state) => {
      state.isLoading = false
    },
    getSupportSocials(state, action) {
      state.isLoading = false
      state.isGetSupportSocialsSuccess = true
      state.supportSocials = action.payload.supportSocials.result
    },
    sendSupportMessage(state, action) {
      state.isLoading = false
      state.isSendSupportMessageSuccess = true
      state.isSendSupportMessageFailed = false
      state.supportMessageResponse = action.payload.supportMessageResponse
    },
  },
})

export const { apiRequest, apiFailure, getSupportSocials, sendSupportMessage } =
  supportSlice.actions

export default supportSlice.reducer
